<template>
    <div class="topbar_right">
        <slot></slot>
    </div>
</template>

<script setup></script>

<style scoped>
.topbar_right {
    @apply flex gap-3 items-center;
}
.topbar_right:empty {
    @apply w-0;
}
</style>
